var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoweredbyKps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 194.28 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8{isolation:isolate;font-size:6.72px;font-family:Roboto-Regular, Roboto;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{fill:#140a9a;}.cls-1{letter-spacing:-0.03em;}.cls-3{letter-spacing:0.01em;}.cls-4{letter-spacing:-0.07em;}.cls-5{letter-spacing:0.01em;}.cls-6{letter-spacing:-0.05em;}.cls-7{letter-spacing:-0.07em;}.cls-8{letter-spacing:0.03em;}.cls-10{fill:#212121;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(112.22 32.18)"
  }, "K"), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(116.2 32.18)"
  }, "O"), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(120.83 32.18)"
  }, "M"), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(126.76 32.18)"
  }, "A"), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(130.64 32.18)"
  }, "T"), /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(134.66 32.18)"
  }, "S"), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(138.73 32.18)"
  }, "U"), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(144.76 32.18)"
  }, "P"), /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(148.67 32.18)"
  }, "A"), /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(153.12 32.18)"
  }, "K"), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(157.42 32.18)"
  }, "I"), /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(159.25 32.18)"
  }, "S"), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(163.29 32.18)"
  }, "T"), /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(166.79 32.18)"
  }, "A"), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(171.25 32.18)"
  }, "N"), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(177.7 32.18)"
  }, "S"), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(181.72 32.18)"
  }, "O"), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(186.35 32.18)"
  }, "F"), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(190.26 32.18)"
  }, "T"), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M112.76.06v23.3h26.49V.06ZM129,19.16l-3.76-5.85L123.68,15v4.18h-3V4.56h3v6.62L125,9.37l3.72-4.82h3.74l-5.21,6.5,5.34,8.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M154,7c-.7,0-2.8,0-2.8,0v4.58h2.69a2.86,2.86,0,0,0,1.82-.55,2.22,2.22,0,0,0,.63-1.64A2.24,2.24,0,0,0,154,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M140.27.06v23.3h26.45V.06Zm17.64,12.73a6.15,6.15,0,0,1-4.09,1.26h-2.63v5.14h-3V4.59h5.68a6.46,6.46,0,0,1,2.9.6,4.47,4.47,0,0,1,1.92,1.71,4.74,4.74,0,0,1,.67,2.52A4.19,4.19,0,0,1,157.91,12.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M167.79,0V23.31h26.45V0Zm11.47,9.59a8.19,8.19,0,0,0,2.11.9,9.22,9.22,0,0,1,3.76,1.92,3.87,3.87,0,0,1,1.18,2.85,3.53,3.53,0,0,1-1.45,3A6.27,6.27,0,0,1,181,19.32,7.48,7.48,0,0,1,178,18.7,4.8,4.8,0,0,1,175.85,17a4.25,4.25,0,0,1-.73-2.46h3c0,1.64,1,2.46,2.89,2.41a2.82,2.82,0,0,0,1.64-.46,1.44,1.44,0,0,0,.6-1.22,1.55,1.55,0,0,0-.6-1.31,7.53,7.53,0,0,0-2.17-1A16.46,16.46,0,0,1,178,12a4.06,4.06,0,0,1-2.46-3.63,3.53,3.53,0,0,1,.67-2.11,4.3,4.3,0,0,1,1.92-1.45A7.31,7.31,0,0,1,181,4.3a6.61,6.61,0,0,1,2.81.57,4.4,4.4,0,0,1,1.89,1.63,4.11,4.11,0,0,1,.68,2.35h-3a2,2,0,0,0-.65-1.59,2.56,2.56,0,0,0-1.78-.57,2.84,2.84,0,0,0-1.72.47,1.5,1.5,0,0,0-.6,1.24,1.41,1.41,0,0,0,.71,1.19Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M0,22.49V9H4.55a5.27,5.27,0,0,1,2.6.57,3.6,3.6,0,0,1,1.49,1.53,4.7,4.7,0,0,1,.49,2.16,4.84,4.84,0,0,1-.48,2.17A3.68,3.68,0,0,1,7.16,17a5.11,5.11,0,0,1-2.58.58H1.32V16.12H4.53a3.51,3.51,0,0,0,1.74-.37,2.25,2.25,0,0,0,1-1,3.77,3.77,0,0,0,0-2.9,2.28,2.28,0,0,0-1-1,3.69,3.69,0,0,0-1.76-.36H1.63v12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M15.55,22.7a4.45,4.45,0,0,1-2.4-.65,4.37,4.37,0,0,1-1.6-1.82A6.07,6.07,0,0,1,11,17.49a6.16,6.16,0,0,1,.58-2.76,4.31,4.31,0,0,1,1.6-1.82,4.36,4.36,0,0,1,2.4-.65,4.26,4.26,0,0,1,4,2.47,6.3,6.3,0,0,1,.58,2.76,6.21,6.21,0,0,1-.58,2.74,4.26,4.26,0,0,1-4,2.47Zm0-1.39a2.65,2.65,0,0,0,1.71-.54,3,3,0,0,0,1-1.4,5.23,5.23,0,0,0,.32-1.88,5.36,5.36,0,0,0-.32-1.89,3.12,3.12,0,0,0-1-1.41,2.65,2.65,0,0,0-1.71-.54,2.63,2.63,0,0,0-1.71.54,3.22,3.22,0,0,0-1,1.41,5.6,5.6,0,0,0-.32,1.89,5.46,5.46,0,0,0,.32,1.88,3.13,3.13,0,0,0,1,1.4A2.63,2.63,0,0,0,15.55,21.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M24.44,22.49l-3.08-10.1H23l2.19,7.73h.1l2.16-7.73H29.1l2.13,7.71h.1l2.19-7.71h1.63l-3.08,10.1H30.54l-2.21-7.76h-.15L26,22.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M41.09,22.7a4.71,4.71,0,0,1-2.51-.65A4.27,4.27,0,0,1,37,20.24a6.15,6.15,0,0,1-.57-2.72A6.24,6.24,0,0,1,37,14.78a4.53,4.53,0,0,1,1.59-1.86,4.34,4.34,0,0,1,2.4-.66,4.63,4.63,0,0,1,1.55.26,3.77,3.77,0,0,1,1.4.85,4,4,0,0,1,1,1.56,6.56,6.56,0,0,1,.38,2.38V18H37.49V16.62H43.7a3.37,3.37,0,0,0-.34-1.52,2.66,2.66,0,0,0-1-1.06,2.7,2.7,0,0,0-1.46-.39,2.77,2.77,0,0,0-1.61.46,3,3,0,0,0-1,1.18,3.51,3.51,0,0,0-.36,1.57v.89a4.36,4.36,0,0,0,.39,1.94,2.81,2.81,0,0,0,1.11,1.2,3.47,3.47,0,0,0,2.76.24,2.31,2.31,0,0,0,1.42-1.4l1.5.42a3.4,3.4,0,0,1-.8,1.34,3.78,3.78,0,0,1-1.38.89A5.13,5.13,0,0,1,41.09,22.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M47.64,22.49V12.39h1.5v1.52h.11a2.4,2.4,0,0,1,1-1.21,2.86,2.86,0,0,1,1.63-.47h.43l.38,0v1.57l-.35-.06a3.81,3.81,0,0,0-.59,0,2.78,2.78,0,0,0-1.31.3,2.33,2.33,0,0,0-.91.85,2.25,2.25,0,0,0-.33,1.22v6.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M58.46,22.7a4.72,4.72,0,0,1-2.52-.65,4.25,4.25,0,0,1-1.62-1.81,6.15,6.15,0,0,1-.57-2.72,6.24,6.24,0,0,1,.57-2.74,4.46,4.46,0,0,1,1.59-1.86,4.31,4.31,0,0,1,2.39-.66,4.73,4.73,0,0,1,1.56.26,3.85,3.85,0,0,1,1.4.85,4.08,4.08,0,0,1,1,1.56,6.56,6.56,0,0,1,.38,2.38V18H54.85V16.62h6.21a3.24,3.24,0,0,0-.34-1.52,2.52,2.52,0,0,0-1-1.06,2.68,2.68,0,0,0-1.46-.39,2.74,2.74,0,0,0-1.6.46,3,3,0,0,0-1,1.18,3.51,3.51,0,0,0-.36,1.57v.89a4.22,4.22,0,0,0,.4,1.94,2.73,2.73,0,0,0,1.1,1.2,3.48,3.48,0,0,0,2.76.24A2.31,2.31,0,0,0,61,19.73l1.5.42a3.29,3.29,0,0,1-.8,1.34,3.78,3.78,0,0,1-1.38.89A5.07,5.07,0,0,1,58.46,22.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M68.82,22.7a3.94,3.94,0,0,1-2.23-.64,4.27,4.27,0,0,1-1.51-1.82,6.44,6.44,0,0,1-.55-2.78,6.38,6.38,0,0,1,.55-2.76,4.25,4.25,0,0,1,1.52-1.81,4.05,4.05,0,0,1,2.25-.63,3.15,3.15,0,0,1,1.56.32,2.74,2.74,0,0,1,.88.74l.48.67h.13V9h1.55V22.49H72V20.94h-.18c-.12.18-.28.41-.49.69a2.71,2.71,0,0,1-.9.74A3.17,3.17,0,0,1,68.82,22.7ZM69,21.31a2.58,2.58,0,0,0,1.58-.49,3,3,0,0,0,1-1.37,5.65,5.65,0,0,0,.33-2,5.41,5.41,0,0,0-.32-2,2.87,2.87,0,0,0-1-1.33A2.59,2.59,0,0,0,69,13.65a2.64,2.64,0,0,0-1.64.5,3,3,0,0,0-1,1.36,5.39,5.39,0,0,0-.33,1.93,5.46,5.46,0,0,0,.34,1.95,3.14,3.14,0,0,0,1,1.4A2.58,2.58,0,0,0,69,21.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M81.92,22.49V9h4.71A5,5,0,0,1,89,9.5a3.23,3.23,0,0,1,1.36,1.3,3.64,3.64,0,0,1,.45,1.8,3,3,0,0,1-.3,1.43,2.53,2.53,0,0,1-.81.9,3.55,3.55,0,0,1-1.07.48v.13a2.62,2.62,0,0,1,1.24.44,3.11,3.11,0,0,1,1.05,1.13,3.58,3.58,0,0,1,.42,1.8,3.67,3.67,0,0,1-.46,1.82A3.21,3.21,0,0,1,89.37,22a6.1,6.1,0,0,1-2.58.47Zm1.63-7.55h3a3.05,3.05,0,0,0,1.33-.29,2.29,2.29,0,0,0,1-.82,2.19,2.19,0,0,0,.35-1.23,2.07,2.07,0,0,0-.62-1.51,2.64,2.64,0,0,0-2-.62H83.55Zm0,6.1h3.24a3.35,3.35,0,0,0,2.27-.62,2,2,0,0,0,.68-1.51,2.42,2.42,0,0,0-.35-1.26,2.67,2.67,0,0,0-1-.94,3.16,3.16,0,0,0-1.52-.35H83.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M94.76,26.28a3,3,0,0,1-.7-.07,1.82,1.82,0,0,1-.43-.12L94,24.73a3.05,3.05,0,0,0,1,.1,1.26,1.26,0,0,0,.78-.38,3.34,3.34,0,0,0,.62-1.12l.29-.79L93,12.39h1.68l2.79,8.05h.11l2.79-8H102L97.73,24a4.44,4.44,0,0,1-.71,1.3A2.78,2.78,0,0,1,96,26,3.23,3.23,0,0,1,94.76,26.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M105.2,15.1a1.18,1.18,0,1,1,1.19-1.19,1.16,1.16,0,0,1-.16.59,1.29,1.29,0,0,1-.43.44A1.22,1.22,0,0,1,105.2,15.1Zm0,7.49a1.13,1.13,0,0,1-.83-.34,1.16,1.16,0,0,1-.35-.84,1.14,1.14,0,0,1,.35-.83,1.17,1.17,0,0,1,1.67,0,1.14,1.14,0,0,1,.35.83,1.18,1.18,0,0,1-.59,1A1.12,1.12,0,0,1,105.2,22.59Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoweredbyKps);
export default __webpack_public_path__ + "static/media/PoweredbyKPS.c656f77e2e9f089e142c9e9bcc42c12c.svg";
export { ForwardRef as ReactComponent };